export const listCustomers = `
   query listCustomers($limit: Int, $nextToken: String) {
       listCustomers(limit: $limit, nextToken: $nextToken) {
           items {
              id
              name
              description
              email
              phone
              delinquent
              created
           }
           nextToken
       }
   }
`;

export const getCustomer = `
   query getCustomer($id:ID!) {
       getCustomer(id:$id) {
         id
         name
         description
         email
         phone
         delinquent
         created
       } 
}`;
